module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs loader-info"
  }, [_c('div', {
    staticClass: "content-loader-and-info"
  }, [_c('div', {
    staticClass: "loader-info-centent-loader"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "L3",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 100 100",
      "enable-background": "new 0 0 0 0",
      "xml:space": "preserve"
    }
  }, [_c('radialGradient', {
    attrs: {
      "id": "radial-gradient",
      "cx": "91.67",
      "cy": "52.21",
      "r": "36.49",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#41b4E8"
    }
  })], 1), _vm._v(" "), _c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M84,46.7C83.1,67.4,66,84,45,84C23.5,84,6,66.5,6,45C6,23.5,23.5,6,45,6c7.4,0,14.3,2.1,20.2,5.6L68,6.3\n            C61.3,2.3,53.4,0,45,0C20.2,0,0,20.1,0,45s20.2,45,45,45c24.4,0,44.2-19.4,45-43.5L84,46.7z"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "dur": "1.2s",
      "type": "rotate",
      "from": "0 45 45",
      "to": "360 45 45",
      "repeatCount": "indefinite"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.displayInfo) ? _c('div', [(_vm.show) ? _c('img', {
    attrs: {
      "src": require("./../../assets/tips.png"),
      "width": "auto",
      "height": "150"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.show) ? _c('img', {
    attrs: {
      "src": require("./../../assets/tips2.png"),
      "width": "auto",
      "height": "150"
    }
  }) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aadb492a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LoaderInfo.vue
// module id = 3339
// module chunks = 0